export interface IMwLoadOptions {
  skip?: number;
  take?: number;
  sort?: Array<object>;
  filter?: Array<any>;
  hasCount?: boolean;
  numericParameters?: object;
  uniqueNamingCaseFields?: object;
  dateFields?: object;
}

export class MwLoadOptions {
  skip = 0;
  take = 0;
  sort = [];
  filter = [];
  hasCount = false;
  numericParameters = {};
  uniqueNamingCaseFields = {};
  dateFields = {};

  constructor(options: IMwLoadOptions) {
    this.skip = options.skip || this.skip;
    this.take = options.take || this.take;
    this.sort = options.sort || this.sort;
    this.filter = options.filter || this.filter;
    this.hasCount = options.hasCount || this.hasCount;
    this.numericParameters =
      options.numericParameters || this.numericParameters;
    this.uniqueNamingCaseFields =
      options.uniqueNamingCaseFields || this.uniqueNamingCaseFields;
    this.dateFields = options.dateFields || this.dateFields;
  }
}
